import { accountSettings } from "../consts/AccountSettings.const";

export const updateNotificationFrequency = (index: number): void => {
    const document = accountSettings.getDocument();

    const frequency = document.latestModel.notifications.settings.notificationFrequency.get();
    if (frequency === null) {
        return;
    }

    const newValue = frequency.options[index];
    if (newValue === undefined) {
        return;
    }
    document.latestModel.notifications.settings.notificationFrequency.update({ value: newValue.key });
};
